import * as Sentry from '@sentry/vue'
import axios, { type AxiosResponse } from 'axios'

export class ApiError extends Error {
  constructor(name: string, ...params: any[]) {
    super(...params)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError)
    }

    this.name = name
    this.stack = (new Error()).stack
  }
}

const ignoreList = ['getpolicy', 'getvisitorsquote', 'visadata']

export const useApiError = (response: AxiosResponse) => {
  if (!response.config) {
    return
  }

  const { url } = response.config

  if (url && ignoreList.some(el => url.includes(el))) {
    return
  }

  Sentry.withScope(scope => {
    const fullURL = `${response.config.baseURL}/${url}`
    const statusCode = (!axios.isAxiosError(response) ? response.status : response.response?.status) || 0
    const data = (!axios.isAxiosError(response) ? response.data : response.response?.data) || null
    const name = `API ERROR [${statusCode}] in [${url}]`
    const message = `URL: ${location.pathname} / API: ${fullURL}`

    if (statusCode === 0) {
      return
    }

    scope.setLevel('error')
    scope.setExtras({
      status: statusCode,
      fullURL,
      params: response.config.params || '',
      request: JSON.stringify(response.config.data || null),
      response: data,
      responseDeep: JSON.stringify(data),
    })
    scope.setTag('quoteno', localStorage.getItem('user-payload.quoteno'))
    scope.setTag('api', true)

    const error = new ApiError(name, message)
    Sentry.captureException(error)
  })
}
